"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const tooltip_1 = require("../tooltip/tooltip");
const button_1 = require("./button");
const TooltipButton = ({ buttonText, disabledButton, disabledTooltip, onClick, style, tooltipMessage, tooltipPlacement, variant = 'primary', width, }) => {
    const [showToolTip, setShowToolTip] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (disabledButton || disabledTooltip)
            setShowToolTip(false);
    }, [disabledButton, disabledTooltip]);
    return ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, Object.assign({ message: tooltipMessage, showTooltip: showToolTip && !disabledButton && !disabledTooltip, placement: tooltipPlacement, offsetValue: 35, width: width }, { children: (0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ onMouseEnter: () => setShowToolTip(true), onMouseLeave: () => setShowToolTip(false), disabled: disabledButton, onClick: onClick, variant: variant, style: style }, { children: buttonText })) })));
};
exports.TooltipButton = TooltipButton;
//# sourceMappingURL=tooltip_button.js.map